/**
 * Enum de ambientes do sistema
 */
export enum EnvironmentEnum {
    DEV = 'DEV',
    TEST = 'TEST',
    PROD = 'PROD',
    HOM = 'HOM'
}
